import { Paths } from "../constants/UrlConstants";
import userManager, {
  userManagerConfig,
  InternalViewPolicy,
  ChangePasswordPolicy,
  ChangeUsernamePolicy,
  PasswordResetPolicy,
  GetSignInSignUpPolicy
} from "../helpers/UserManagerHelper";
import store from "../Store";
import { MyProfileChangeIndicator } from "../constants/Constants";

const changeMemberDetailForB2CPolicy = (memberDetail, policyName) => {
  var selectedPolicyMembershipNumber = store.getState().policyReducer
    .selectedPolicy.MembershipNumber;
  userManagerConfig.extraQueryParams.p = policyName;
  userManager.signinRedirect({
    state: {
      redirectPath: Paths.MyProfile,
      memberDetailUpdated: memberDetail,
      selectedPolicyMembershipNumber
    }
  });
};

export const RedirectToLogin = async (signInRedirectUrl) => {
  userManagerConfig.extraQueryParams.p = GetSignInSignUpPolicy();
  userManager.signinRedirect({
    state: { redirectPath: signInRedirectUrl }
  });
};

export const InternalViewErrorMessage =
  "Something went wrong while redirecting to internal view";

export const RedirectToInternalViewLogin = (internalviewtoken) => {
  userManagerConfig.extraQueryParams.p = InternalViewPolicy;
  userManager.signinRedirect({
    state: { internalviewtoken: internalviewtoken }
  });
};

export const SilentRedirectToLogin = async () => {
  const state = store.getState();
  let user = state && state.oidc && state.oidc.user;

  if (!user || user.expired) {
    userManagerConfig.extraQueryParams.p = GetSignInSignUpPolicy();

    return await userManager.signinSilent().catch((response) => {
      throw response.error;
    });
  } else {
    return user;
  }
};

export const ChangeB2CPassword = () => {
  changeMemberDetailForB2CPolicy(
    MyProfileChangeIndicator.Password,
    ChangePasswordPolicy
  );
};

export const ChangeB2CUsername = () => {
  changeMemberDetailForB2CPolicy(
    MyProfileChangeIndicator.EmailAddress,
    ChangeUsernamePolicy
  );
};

export const ResetB2CPassword = () => {
  userManagerConfig.extraQueryParams.p = PasswordResetPolicy;
  userManager.signinRedirect();
};
